"use client";
import { createContext, useContext } from "react";
const defaultTableRowExpandableContext = {
    isExpandable: false,
    expandedContent: void 0,
    setExpandedContent: ()=>{},
    isExpanded: false,
    setIsExpanded: ()=>{}
};
const TableRowExpandableContext = /*#__PURE__*/ createContext(defaultTableRowExpandableContext);
const useTableRowExpandableContext = ()=>useContext(TableRowExpandableContext);
export { TableRowExpandableContext, defaultTableRowExpandableContext, useTableRowExpandableContext };
